/**
* Video Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'video-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.video-banner-button' ).hover( function( ) {
        const mediaWrap = $( this ).closest( '.video-banner' ).find( '.video-banner-media-wrap' );
        $( mediaWrap ).addClass( 'blur-on-hover' );
      }, function( ) {
        const mediaWrap = $( this ).closest( '.video-banner' ).find( '.video-banner-media-wrap' );
        $( mediaWrap ).removeClass( 'blur-on-hover' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-banner', COMPONENT );
} )( app );
